/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoRegimen from 'Infotrack@Modelos/administracion/tipoRegimen/entidades/tipoRegimen';
import React from 'react';
import TipoRegimenCM from '../controladorModelo/tipoRegimenCM';
import { acciones, IEstadoTipoRegimen } from '../reductorTipoRegimen';
import FormularioTipoRegimenVista from '../vista/formularioTipoRegimenVista';

const estadoInicial: ITipoRegimen = {
    CodigoTipoRegimen: '',
    NombreTipoRegimen: '',
    EstadoTipoRegimen: true,
};
const tipoRegimenCM = new TipoRegimenCM();

const FormularioTipoRegimenCV: React.FunctionComponent = () => {
    const [{ estadoFormulario, tipoFormulario, entidadTipoRegimen }, dispatch] = useProveedor<IEstadoTipoRegimen>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<ITipoRegimen>(estadoInicial);

    React.useEffect(() => {
        if (entidadTipoRegimen && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadTipoRegimen);
        } else {
            reiniciar();
        }
    }, [entidadTipoRegimen]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionTipoRegimen = () => {
        if (tipoRegimenCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarTipoRegimen,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarTipoRegimen = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            tipoRegimenCM.crearTipoRegimen(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            tipoRegimenCM.editarTipoRegimen(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    return (
        <FormularioTipoRegimenVista
            accionCrearEditar={confirmarCreacionEdicionTipoRegimen}
            cambiarInfoFomulario={alCambiarValor}
            tipoRegimen={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

export default FormularioTipoRegimenCV;
